import FlawOptions from './FlawOptions';

export default FlawOptions;
